import { render, staticRenderFns } from "./product_info.vue?vue&type=template&id=fed5af96&"
import script from "./product_info.vue?vue&type=script&lang=js&"
export * from "./product_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fed5af96')) {
      api.createRecord('fed5af96', component.options)
    } else {
      api.reload('fed5af96', component.options)
    }
    module.hot.accept("./product_info.vue?vue&type=template&id=fed5af96&", function () {
      api.rerender('fed5af96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/reports/entry_fee/form/product_info.vue"
export default component.exports